import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import {
  GripVertical,
  ChevronUp,
  ChevronDown,
  Trash2,
} from 'lucide-react'

export default function CarouselItem({
  item,
  index,
  total,
  onMoveUp,
  onMoveDown,
  onDelete,
  children,
}: any) {
  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center gap-3 p-3 border rounded-lg bg-white shadow-sm dark:bg-slate-900 dark:border-slate-700"
    >
      {/* DRAG HANDLE */}
      <div
        {...attributes}
        {...listeners}
        className="cursor-grab active:cursor-grabbing text-gray-400"
      >
        <GripVertical size={18} />
      </div>

      {/* CONTENT */}
      <div className="flex-1">{children}</div>

      {/* ACTIONS */}
      <div className="flex items-center gap-1">
        <button
          type='button'
          onClick={onMoveUp}
          disabled={index === 0}
          className="p-1 hover:bg-gray-200 disabled:opacity-40 rounded"
        >
          <ChevronUp size={18} />
        </button>

        <button
          type='button'
          onClick={onMoveDown}
          disabled={index === total - 1}
          className="p-1 hover:bg-gray-200 disabled:opacity-40 rounded"
        >
          <ChevronDown size={18} />
        </button>

        <button
          onClick={onDelete}
          className="p-1 text-red-500 hover:bg-red-50 rounded"
        >
          <Trash2 size={18} />
        </button>
        {/* Tooltip */}
        <div className="relative group mr-auto ml-2 mt-0">
          <InformationCircleIcon className="w-4 h-4 text-slate-500 cursor-pointer" />

          <div className="absolute bottom-full right-0 -translate-y-0 mb-2 w-64 rounded-md bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 p-3 text-xs text-slate-700 dark:text-slate-200 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 z-50
                                                                    ">
            You can change the order of items (up to one level) using the up and down arrows.
          </div>
        </div>
      </div>
    </div>
  )
}
